import { Component, OnInit } from '@angular/core';
import { StorageConstants } from '@picard/shared-lib';
import { PreAuthenticationResponse } from '@picard/models-lib';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  //#region Properties
  preAuthenticationResponse: PreAuthenticationResponse;
  public date: Date;
  //#endregion Properties

  //#region Constructor
  constructor() {
    this.date = new Date();
  }
  //#endregion Constructor

  //#region Functions
  ngOnInit() {
    const preAuthAsJson = sessionStorage.getItem(StorageConstants.preAuth);
    if (preAuthAsJson) {
      this.preAuthenticationResponse = JSON.parse(preAuthAsJson);
    }
  }
  isMobile() {
    return window.innerWidth <= 1024;
  }
  //#endregion Functions
}
